// extracted by mini-css-extract-plugin
export default {"title":"Title_title__UZ3cW","mainButton":"Title_mainButton__9o4MN"};